import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { Router } from 'react-router';

import { compose, createStore, applyMiddleware } from 'redux';
import thunkMiddleware from 'redux-thunk';
// Redux Persist
import { persistStore, autoRehydrate } from 'redux-persist';
import { asyncSessionStorage } from 'redux-persist/storages';

// Component, Route, and Lib
import { routeDidUpdate } from './actions/actions-router';

import largeScreenRoutes from './routes/LargeScreenRoutes';
import mobileRoutes from './routes/MobileRoutes';
import rootReducer from './reducers/index';
import HelpApp from './components/HelpApp';
import Page from '../lib/page';
import getHistory from '../lib/HistoryHelper';

const middlewares = [
  thunkMiddleware,
];

if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line  global-require
  const createLogger = require('redux-logger');
  middlewares.push(createLogger());
}

const store = createStore(rootReducer,
  undefined,
  compose(
    autoRehydrate(),
    applyMiddleware(...middlewares)),
  );

persistStore(store, {
  storage: asyncSessionStorage,
  whitelist: [],
});

// Todo: below `basename` should be updated to `US`.
const history = getHistory();

window.histTest = history;

const currentLocation = history.location;

store.dispatch(routeDidUpdate(currentLocation));

// TODO: wire to acrtions-router after backend code
// store.dispatch(getArticleListByTopic());

history.listen((location) => {
  store.dispatch(routeDidUpdate(location));
});

// TODO: should come from server
const routeConfig = Page.isMobileLayout() ? mobileRoutes : largeScreenRoutes;

ReactDOM.render(
  <Provider store={store}>
    <Router history={history}>
      <HelpApp sideBar={routeConfig.sideBar} mainContainer={routeConfig.mainContainer} />
    </Router>
  </Provider>,
  document.querySelector('.smarthelp-react-app'),
);



// WEBPACK FOOTER //
// ./home/index.js